import type { AppRedirect } from '#src/shared/routes';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const buildFeedUrl: AppRedirect['buildUrl'] = ({ params: { slug }, queryString }) => `/p/${slug!}/feed${queryString}`;

export const REDIRECTS: readonly AppRedirect[] = [
	// These are legacy comment list pages. See README for details.
	{
		path: '/p/:slug/c',
		buildUrl: buildFeedUrl,
		reason: 'deprecated-url',
	},
	{
		path: '/p/:slug/comments',
		buildUrl: buildFeedUrl,
		reason: 'deprecated-url',
	},
	{
		path: '/p/:slug/reasons_for_signing',
		buildUrl: buildFeedUrl,
		reason: 'deprecated-url',
	},
];
